"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDefaults = exports.extractKeysAsTuple = exports.extractValuesAsTuple = void 0;
const zod_1 = require("zod");
function extractValuesAsTuple(obj) {
    const values = Object.values(obj);
    if (values.length === 0)
        throw new Error('Object must have at least one value.');
    // Explicitly extract the first value
    const result = [values[0], ...values.slice(1)];
    return result;
}
exports.extractValuesAsTuple = extractValuesAsTuple;
function extractKeysAsTuple(obj) {
    const keys = Object.keys(obj);
    if (keys.length === 0)
        throw new Error('Object must have at least one key.');
    // Explicitly extract the first key
    const result = [keys[0], ...keys.slice(1)];
    return result;
}
exports.extractKeysAsTuple = extractKeysAsTuple;
/* eslint-disable @typescript-eslint/no-explicit-any,no-console */
function extractDefaults(schema, options) {
    var _a, _b, _c, _d;
    const defaultArrayEmpty = (_a = options === null || options === void 0 ? void 0 : options.defaultArrayEmpty) !== null && _a !== void 0 ? _a : true;
    const defaultDateEmpty = (_b = options === null || options === void 0 ? void 0 : options.defaultDateEmpty) !== null && _b !== void 0 ? _b : false;
    const defaultDateUndefined = (_c = options === null || options === void 0 ? void 0 : options.defaultDateUndefined) !== null && _c !== void 0 ? _c : false;
    const defaultDateNull = (_d = options === null || options === void 0 ? void 0 : options.defaultDateNull) !== null && _d !== void 0 ? _d : false;
    function process() {
        if (schema instanceof zod_1.z.ZodEffects) {
            if (schema.innerType() instanceof zod_1.z.ZodEffects) {
                return extractDefaults(schema.innerType(), options); // recursive ZodEffect
            }
            // return schema inner shape as a fresh zodObject
            return extractDefaults(zod_1.z.ZodObject.create(schema.innerType().shape), options);
        }
        if (schema instanceof zod_1.z.ZodDefault) {
            const defValues = schema._def.defaultValue();
            const shape = schema._def.innerType._def.shape;
            const temp = Object.entries(shape).map(([key, value]) => {
                if (defValues[key] !== undefined) {
                    return [key, defValues[key]];
                }
                else if (value instanceof zod_1.z.ZodEffects ||
                    value instanceof zod_1.z.ZodDefault) {
                    return [key, extractDefaults(value, options)];
                }
                else {
                    return [key, getDefaultValue(value)];
                }
            });
            return Object.assign(Object.assign({}, Object.fromEntries(temp)), defValues);
        }
        if (schema instanceof zod_1.z.ZodType) {
            const the_shape = schema.shape; // eliminates 'undefined' issue
            const entries = Object.entries(the_shape);
            const temp = entries.map(([key, value]) => {
                const this_default = value instanceof zod_1.z.ZodEffects
                    ? extractDefaults(value, options)
                    : getDefaultValue(value);
                return [key, this_default];
            });
            return Object.fromEntries(temp);
        }
        else {
            console.error(`Error: Unable to process this schema`);
            return null; // unknown or undefined here results in complications
        }
        function getDefaultValue(dschema) {
            var _a;
            if (dschema == null)
                return undefined;
            if (dschema instanceof zod_1.z.ZodDefault) {
                if (!('_def' in dschema))
                    return undefined; // error
                if (!('defaultValue' in dschema._def))
                    return undefined; // error
                return dschema._def.defaultValue();
            }
            if (dschema instanceof zod_1.z.ZodArray) {
                if (!('_def' in dschema))
                    return undefined; // error
                if (!('type' in dschema._def))
                    return undefined; // error
                // return empty array or array with one empty typed element
                return defaultArrayEmpty
                    ? []
                    : [getDefaultValue(dschema._def.type)];
            }
            if (dschema instanceof zod_1.z.ZodString)
                return '';
            if (dschema instanceof zod_1.z.ZodNumber || dschema instanceof zod_1.z.ZodBigInt) {
                const value = (_a = dschema.minValue) !== null && _a !== void 0 ? _a : 0;
                return value;
            }
            if (dschema instanceof zod_1.z.ZodDate) {
                const value = defaultDateEmpty
                    ? ''
                    : defaultDateNull
                        ? null
                        : defaultDateUndefined
                            ? undefined
                            : dschema.minDate;
                return value;
            }
            if (dschema instanceof zod_1.z.ZodSymbol)
                return '';
            if (dschema instanceof zod_1.z.ZodBoolean)
                return false;
            if (dschema instanceof zod_1.z.ZodNull)
                return null;
            if (dschema instanceof zod_1.z.ZodPipeline) {
                if (!('out' in dschema._def))
                    return undefined; // error
                return getDefaultValue(dschema._def.out);
            }
            if (dschema instanceof zod_1.z.ZodObject) {
                return extractDefaults(dschema, options);
            }
            if (dschema instanceof zod_1.z.ZodAny && !('innerType' in dschema._def))
                return undefined; // error?
            return getDefaultValue(dschema._def.innerType);
        }
    }
    return process();
}
exports.extractDefaults = extractDefaults;
//# sourceMappingURL=extract.js.map